import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-marketing-and-sales',
  imports: [PillarPagesTemp],
  templateUrl: './marketing-and-sales.html',
  styleUrl: './marketing-and-sales.scss',
})
export class MarketingAndSales {

}
